import { createContext, useContext, useState, type MutableRefObject } from 'react';
import { useResizeObserver } from '@atlassian/jira-react-use-resize-observer/src/index.tsx';
import { ScreenSize, ScreenThreshold } from '../common/constants.tsx';

type isCompactViewProps = {
	ref: MutableRefObject<HTMLDivElement | null>;
};

export const ContainerSizeContext = createContext<{ size: ScreenSize | undefined }>({
	size: ScreenSize.MEDIUM,
});

export const useContainerSize = () => useContext(ContainerSizeContext);

function getBacklogContainerSize(offsetWidth: ScreenThreshold | undefined): ScreenSize {
	if (offsetWidth === undefined) {
		return ScreenSize.MEDIUM;
	}
	if (offsetWidth < ScreenThreshold.EXTRA_SMALL) {
		return ScreenSize.EXTRA_SMALL;
	}
	if (offsetWidth > ScreenThreshold.EXTRA_SMALL && offsetWidth < ScreenThreshold.SMALL) {
		return ScreenSize.SMALL;
	}
	if (offsetWidth > ScreenThreshold.SMALL && offsetWidth < ScreenThreshold.MEDIUM) {
		return ScreenSize.MEDIUM;
	}
	if (offsetWidth > ScreenThreshold.MEDIUM && ScreenThreshold.LARGE) {
		return ScreenSize.LARGE;
	}
	return ScreenSize.EXTRA_LARGE;
}
export function useBacklogContainerSize({ ref }: isCompactViewProps): ScreenSize | undefined {
	const [backlogContainerSize, setBacklogContainerSize] = useState(
		ref.current?.offsetWidth !== undefined
			? getBacklogContainerSize(ref.current?.offsetWidth)
			: ScreenSize.MEDIUM,
	);

	useResizeObserver({
		ref,
		onResize() {
			if (ref.current) {
				const { offsetWidth } = ref.current;
				setBacklogContainerSize(
					offsetWidth !== undefined ? getBacklogContainerSize(offsetWidth) : ScreenSize.MEDIUM,
				);
			}
		},
	});

	return backlogContainerSize;
}
